module.exports = __webpack_public_path__ + "static/img/return_bad_example_4.222751e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/return_bad_example_4.jpg
// module id = e/jT
// module chunks = 1